import Util from '../../common/Util';
import {container} from './NoMovieVisualTmpl';

export default class NoMovieVisual {
    constructor(_container){
        this.nameIs = 'class-NoMovieVisual';
        this.container = _container;

        $(_container).addClass('is-theme'+ Util.randomNum(3,1));
        $(_container).html( container() );


            
        let controller = new ScrollMagic.Controller();

        TweenMax.set('.visual-title', {
            css: {
                'margin-top': '100px',
                'background-position-y': '0%'
            }
        });
        new ScrollMagic.Scene({triggerElement: ".content", duration: 500}).setTween('.visual-title', {
            css: {
                'margin-top': '250px',
                'background-position-y': '100%'
            }
        }).addTo(controller);
    }

    addEvents(){}
    
} // end of class